import { render, staticRenderFns } from "./ygpj.vue?vue&type=template&id=4471f002&scoped=true&"
import script from "./ygpj.vue?vue&type=script&lang=js&"
export * from "./ygpj.vue?vue&type=script&lang=js&"
import style0 from "./ygpj.vue?vue&type=style&index=0&id=4471f002&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4471f002",
  null
  
)

export default component.exports